export default __webpack_public_path__ + "static/media/full-bundle-accuchek-white@2x.9d4e85d1.webp";